import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@services/translate/translate.service';
import * as _ from 'lodash';

@Pipe({
    name: 'translate', pure: false,
    standalone: false
})
export class TranslatePipe implements PipeTransform {
  constructor(private translate: TranslateService) {
  }

  transform(key: any): any {
    return _.get(this.translate.data, key) || key;
  }
}
